import { Button, Dialog, DialogContent, DialogTitle, Divider } from "@mui/material";
import type { PropsWithChildren } from "react";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import DialogCloseButton from "@entrilia/shared/components/DialogCloseButton";

interface Props {
  onClose: () => void;
}

const InvestorCommunicationContentPreviewDialog = ({ onClose, children }: PropsWithChildren<Props>) => (
  <Dialog open fullWidth maxWidth="lg" onClose={onClose}>
    <DialogTitle>Content preview</DialogTitle>
    <DialogCloseButton onClick={onClose} />
    <Divider />
    <DialogContent sx={{ display: "flex", flexDirection: "column" }}>{children}</DialogContent>
    <Divider />
    <DialogButtons>
      <Button variant="contained" onClick={onClose}>
        Close
      </Button>
    </DialogButtons>
  </Dialog>
);

export default InvestorCommunicationContentPreviewDialog;
